// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchBar_container__2FvN8","form":"SearchBar_form__34a22"};